import _ from 'lodash';
import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons/faEyeSlash';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/core/designs';

const ListDesigns = ({
  filter = {}, actions, onRowClick, segment, fileImport = true,
}) => (
  <ListResource
    {...{
      searchable: [
        { value: 'All', label: 'All' },
        {
          value: 'photos',
          label: 'Picture',
          options: [
            { value: true, label: 'With Picture' },
            { value: false, label: 'Without Picture' },
          ],
        },
        {
          value: 'arStatus',
          label: 'AR',
          options: [
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Active but manual suppress' },
          ],
        },
      ],
      api,
      sort: { design: 1 },
      filter,
      actions: {
        fileExport: true,
        fileImport: { accept: '.json' },
        ...actions,
      },
      extraActions: [
        {
          type: 'import',
          api: {
            url: '/api/core/designs/uploadArAssets',
          },
          fileOpts: {
            accept: '.zip',
          },
          children: 'Upload AR Assets',
          onSuccess: ({ data: { logs } }) => ({
            showIcon: false,
            children: (
              <div>{_.map(_.castArray(logs), (r, i) => (
                <div key={i}>{JSON.stringify(r)}</div>
              ))}</div>
            ),
          }),
        },
      ],
      cols: [
        {
          key: 'active',
          sortable: true,
          getter(v) {
            return <FA icon={v ? faCheckCircle : faTimesCircle} />;
          },
        },
        {
          key: 'variation',
          children: 'AR',
          sortable: false,
          getter(v, { arActive }) {
            if (!_.find(v, (x) => !_.isEmpty(x.arImg) && !_.isEmpty(x.arModel))) return <FA icon={faTimesCircle} />;
            if (!arActive) return <FA icon={faEyeSlash} />;
            return <FA icon={faCheckCircle} />;
          },
        },
        { key: 'brand', sortable: true },
        { key: 'coll.name', children: 'Collection', sortable: true },
        { key: 'design', sortable: true },
        { key: 'gdn', children: 'GDN', sortable: true },
      ],
      onRowClick,
      segment,
    }}>
    {({ selected, refresh }) => fileImport && (
        <>
          <ListCtrlActivates api={api} selected={selected} onSuccess={refresh} />
        </>
    )}
  </ListResource>
);

export default ListDesigns;
